import styled, { css } from "styled-components";
import { dark } from "../../colors";
import { buttonreset } from "../../utils/snippets";
import { lineHeight, minTapSize, spacing } from "../../dimensions";
import { darker, muted, light, transparent } from "../../colors/modifiers";
var variantStyles = function variantStyles(_ref) {
  var $fillVariant = _ref.$fillVariant,
    $colorVariant = _ref.$colorVariant,
    theme = _ref.theme;
  var fg = theme._buttons[$colorVariant].color;
  var bg = theme._buttons[$colorVariant].backgroundColor;

  // inverse colorVariant overrides any fillVariant
  if ($colorVariant === "inverse") {
    return css(["border-color:", ";color:", ";background-color:transparent;"], bg, bg);
  }
  switch ($fillVariant) {
    case "outline":
      return css(["border-color:", ";color:", ";background-color:transparent;"], $colorVariant === "tertiary" ? muted(bg) : bg, bg);
    case "ghost":
      return css(["border-color:transparent;color:", ";background-color:transparent;@media (-ms-high-contrast:active),(forced-colors:active){padding-right:", ";padding-left:", ";}"], bg, spacing.amphitheatre, spacing.amphitheatre);
    case "fill":
    default:
      return css(["border-color:transparent;color:", ";background-color:", ";"], fg, bg);
  }
};
var hoverStyles = function hoverStyles(_ref2) {
  var $fillVariant = _ref2.$fillVariant,
    $colorVariant = _ref2.$colorVariant,
    theme = _ref2.theme;
  var fg = theme._buttons[$colorVariant].color;
  var bg = theme._buttons[$colorVariant].backgroundColor;
  var darkBg = dark(bg);

  // inverse colorVariant overrides any fillVariant
  if ($colorVariant === "inverse") {
    return css(["color:", ";background-color:", ";"], fg, bg);
  }
  switch ($fillVariant) {
    case "outline":
      return css(["border-color:", ";color:", ";background-color:", ";"], darkBg, fg, darkBg);
    case "ghost":
      return css(["color:", ";background-color:", ";"], darkBg, transparent(light(bg)));
    case "fill":
    default:
      return css(["border-color:", ";color:", ";background-color:", ";"], darkBg, fg, darkBg);
  }
};
var fontSize = css(["font-size:", "px;"], function (props) {
  // Designs have different font sizes for the "Transactional" buttons
  // This is for accessibility reasons as white text on green background is slightly
  // harder to read, so we make the text a bit bigger to mitigate that.
  return props.$colorVariant === "transaction" ? props.theme.fontSizes[3] : props.theme.fontSizes[2];
});
var buttonActiveStyles = function buttonActiveStyles(_ref3) {
  var $colorVariant = _ref3.$colorVariant,
    $fillVariant = _ref3.$fillVariant,
    theme = _ref3.theme;
  var fg = theme._buttons[$colorVariant].color;
  var bg = theme._buttons[$colorVariant].backgroundColor;
  var getColor = function getColor() {
    if ($colorVariant === "inverse") {
      return bg;
    }
    if ($fillVariant === "ghost") {
      return fg;
    }
    return;
  };
  var activeColor = $colorVariant === "transaction" ? theme._buttons["transaction"].backgroundColor : theme._buttons["primary"].backgroundColor;
  return css(["border-color:", ";color:", ";background-color:", ";"], darker(activeColor), getColor(), darker(activeColor));
};
var buttonDisabledStyles = function buttonDisabledStyles(props) {
  var $colorVariant = props.$colorVariant,
    $fillVariant = props.$fillVariant;
  var getDisabledGhostStyles = function getDisabledGhostStyles() {
    return css(["border-color:transparent;color:", ";background-color:transparent;cursor:not-allowed;"], props.theme._buttons.disabled.color);
  };
  var getDisabledOutlineStyles = function getDisabledOutlineStyles() {
    return css(["border-color:", ";color:", ";background-color:transparent;cursor:not-allowed;"], props.theme._buttons.disabled.color, props.theme._buttons.disabled.color);
  };
  if ($fillVariant === "ghost") {
    return getDisabledGhostStyles();
  }
  if ($fillVariant === "outline") {
    return getDisabledOutlineStyles();
  }
  switch ($colorVariant) {
    case "inverse":
      return css(["opacity:0.6;"]);
    default:
      return css(["border-color:", ";color:", ";background-color:", ";cursor:not-allowed;"], props.theme._buttons.disabled.backgroundColor, props.theme._buttons.disabled.color, props.theme._buttons.disabled.backgroundColor);
  }
};
var baseButtonStyles = css(["", ";", ";position:relative;display:inline-block;width:", ";min-height:", ";padding:", " ", ";border-style:solid;border-width:1px;border-radius:4px;font-weight:600;", " line-height:", ";white-space:nowrap;text-align:center;text-wrap:auto;@supports (text-wrap:pretty){text-wrap:pretty;}transition:background-color 0.2s;&:disabled{", "}&:not(:disabled){cursor:", ";}&:focus{outline-offset:4px;}&:not(:disabled):hover{", "}&:not(:disabled):active{", "}"], buttonreset, variantStyles, function (props) {
  return props.$fullWidth === true ? "100%" : "auto";
}, minTapSize, spacing.club, spacing.auditorium, fontSize, lineHeight["default"], buttonDisabledStyles, function (props) {
  return props.$showLoadingState ? "wait" : "pointer";
}, function (props) {
  return !props.$showLoadingState && hoverStyles;
}, function (props) {
  return !props.$showLoadingState && buttonActiveStyles;
});
var linkStyles = css(["display:inline-flex;align-items:center;justify-content:center;text-decoration:none;&:hover,&:focus{text-decoration:none;}&[aria-disabled=\"true\"]{", ";&:focus,&:hover{", "}}"], buttonDisabledStyles, buttonDisabledStyles);
export var StyledButton = styled.button.withConfig({
  displayName: "indexstyles__StyledButton",
  componentId: "sc-83qv1q-0"
})(["", ";", ";"], baseButtonStyles, function (props) {
  return !props.type && linkStyles;
});
export var FlexWrapper = styled.span.withConfig({
  displayName: "indexstyles__FlexWrapper",
  componentId: "sc-83qv1q-1"
})(["display:flex;align-items:center;justify-content:center;visibility:", ";"], function (props) {
  return props.$isLoading ? "hidden" : "visible";
});
export var Text = styled.span.withConfig({
  displayName: "indexstyles__Text",
  componentId: "sc-83qv1q-2"
})(["padding-right:", ";padding-left:", ";"], function (props) {
  return props.$spaceRight && spacing.club;
}, function (props) {
  return props.$spaceLeft && spacing.club;
});
export var LoadingContainer = styled.span.withConfig({
  displayName: "indexstyles__LoadingContainer",
  componentId: "sc-83qv1q-3"
})(["position:absolute;top:0;right:0;bottom:0;left:0;display:flex;align-items:center;justify-content:center;"]);